exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pageTitle--nAvj_ {\r\n\tline-height: 42px !important;\r\n}\r\n\r\n.pageHeaderWrap--3PTaD {\r\n\tpadding: 0 24px;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -webkit-flex;\r\n\tdisplay: -moz-box;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-webkit-align-items: center;\r\n\t   -moz-box-align: center;\r\n\t        align-items: center;\r\n}\r\n\r\n.buttonIcon--2REy3 {\r\n\tmargin-right: 8px;\r\n}\r\n", ""]);

// Exports
exports.locals = {
	"pageTitle": "pageTitle--nAvj_",
	"pageHeaderWrap": "pageHeaderWrap--3PTaD",
	"buttonIcon": "buttonIcon--2REy3"
};